<table>
    <thead>
        <th>Name</th>
        <th>Labor</th>
        <th>Material</th>
        <th>Length</th>
        <th>Qty</th>
        <th>Cost</th>
    </thead>
    <tbody>
        <ng-container *ngFor="let key of tallyKeys">
            <tr class="report-data" *ngIf="HasValue(key)">
                <td [innerHTML]="GetAttributeName(key)"></td>
                <td [innerHTML]="GetTallyItem(key,'labor')"></td>
                <td [innerHTML]="GetTallyItem(key,'materials')"></td>
                <td [innerHTML]="GetTallyItem(key,'length')"></td>
                <td [innerHTML]="GetTallyItem(key,'qty')"></td>
                <td [innerHTML]="GetTallyItem(key,'cost')"></td>
            </tr>
        </ng-container>
    </tbody>
</table>
